export default "__VITE_ASSET__CeDGUGhl__"